import { render } from "./AboutEJF.vue?vue&type=template&id=5d3c7d3f&scoped=true"
import script from "./AboutEJF.vue?vue&type=script&lang=js"
export * from "./AboutEJF.vue?vue&type=script&lang=js"

import "./AboutEJF.vue?vue&type=style&index=0&id=5d3c7d3f&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3c7d3f"]])

export default __exports__